import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M0 5.634a6.006 6.006 0 1 1 5.992 6.377H2.75A2.754 2.754 0 0 1 0 9.262zm1.5 3.627a1.25 1.25 0 0 0 1.25 1.25h3.242a4.52 4.52 0 0 0 4.303-3.143 4.5 4.5 0 0 0 .176-1.88 4.52 4.52 0 0 0-4.48-3.977 4.47 4.47 0 0 0-2.87 1.033A4.52 4.52 0 0 0 1.5 5.706z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.25 5.511h-1.5a.75.75 0 1 1 0-1.5h1.5a.75.75 0 1 1 0 1.5M3.75 6.6h3.5a.75.75 0 1 1 0 1.5h-3.5a.75.75 0 1 1 0-1.5"
    }, null, -1)
  ]))]))
}
export default { render: render }